import { z } from 'zod';
/**
 * A firm's own colour (design direction J): `#rrggbb` in lower case, as the firm chose it. Kanos
 * keeps it as chosen and adapts only its lightness per theme, so that text and marks in it stay
 * legible (WCAG 2.2 AA) - the colour the firm sees is its own, never a guess.
 */
export const AccentColor = z
    .string()
    .regex(/^#[0-9a-f]{6}$/)
    .meta({ id: 'AccentColor', examples: ['#1e3a8a'] });
/** `GET`/`PUT /api/v1/firm/appearance`: how the firm's surfaces look. */
export const FirmAppearance = z
    .object({
    accentColor: AccentColor.nullable().describe('The firm colour; `null`: the Kanos colour (blue #0056ff).'),
})
    .meta({ id: 'FirmAppearance' });
/** The firm's logo as kept (ADR-041): a PNG Kanos rendered anew, at most 1200 × 400 pixels. */
export const FirmLogo = z
    .object({
    /** SHA-256 of the image: changes with every new logo, so addresses with it may be cached. */
    version: z.string().regex(/^[0-9a-f]{64}$/),
    width: z.number().int().positive(),
    height: z.number().int().positive(),
    updatedAt: z.iso.datetime({ offset: true }),
})
    .meta({ id: 'FirmLogo' });
/** `GET /api/v1/firm/logo/meta`: the logo, or `null` while the firm has none. */
export const FirmLogoState = z.object({ logo: FirmLogo.nullable() }).meta({ id: 'FirmLogoState' });
/** Largest logo Kanos keeps, in pixels: the frame of the crop (3 : 1). */
export const FIRM_LOGO_MAX = { width: 1200, height: 400 };
/** `?v=`: the logo's version in its address - so a cache may keep that very image for long. */
export const LogoVersionQuery = z
    .object({
    v: z
        .string()
        .regex(/^[0-9a-f]{64}$/)
        .optional(),
})
    .meta({ id: 'LogoVersionQuery' });
//# sourceMappingURL=firm-appearance.js.map